module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Layout', [_c('SubHeader', {
    attrs: {
      "slot": "sub-header",
      "title": _vm.$t('course.title'),
      "isBackground": false
    },
    slot: "sub-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "card-course-view",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.busy) ? _c('LoadingBounce', {
    staticClass: "w-100"
  }) : [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 px-12 mt-6 px-6"
  }, [_c('CourseCard', {
    attrs: {
      "course": _vm.cardCourse,
      "isCardList": true
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "course-description"
  }, [_vm._v("\n        " + _vm._s(_vm.courseDescription) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "course-created-date"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('common.created_date')) + " " + _vm._s(_vm.courseCreatedDate) + "\n      ")]), _vm._v(" "), (_vm.cardCourseLectures.length > 0) ? _c('div', {
    staticClass: "course-lectures"
  }, [_c('div', {
    staticClass: "row align-items-center header"
  }, [_c('div', {
    staticClass: "col-8 title px-0"
  }, [_vm._v(_vm._s(_vm.$t('course.card_lecture')) + " " + _vm._s(_vm.cardLectureCount))]), _vm._v(" "), _c('div', {
    staticClass: "col-4 action px-0"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.cardCourseLectures), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-3 col-md-3 col-sm-6 col-6 px-6 mb-2 mt-6"
    }, [_c('ImageCard', {
      attrs: {
        "cardLecture": item,
        "eventLabel": 'card_course.lecture',
        "isCourseCard": true,
        "courseId": _vm.courseId
      }
    })], 1)
  }), _vm._v(" "), (_vm.cardCourseLectures.length >= 10) ? _c('InfiniteLoading', {
    staticClass: "w-100",
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('LoadingBounce')], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  })]) : _vm._e()], 2)]) : _vm._e()]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29bd0260","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/course/views/CardCourseView.vue
// module id = 1563
// module chunks = 1